import { jsx as l } from "react/jsx-runtime";
import { forwardRef as f, useRef as g, useImperativeHandle as T, useEffect as v } from "react";
import u from "classnames";
import { Tabs as i } from "../tabs/tabs.js";
import c from "./segments.module.less.js";
const w = f(
  function({ className: s, variant: t = "blue", ...r }, e) {
    return /* @__PURE__ */ l(
      i,
      {
        ...r,
        ref: e,
        className: u(c[t], s)
      }
    );
  }
), S = f(
  function({ className: s, ...t }, r) {
    const e = g(null);
    return T(r, () => e.current), v(() => {
      if ("ResizeObserver" in window && e.current) {
        let m = !1;
        const n = e.current, o = n.querySelectorAll('[role="tab"]'), a = new ResizeObserver(() => {
          if (m || !o[0])
            return m = !1;
          const p = o[0].offsetTop < o[o.length - 1].offsetTop;
          a.unobserve(n), n.setAttribute("data-pills", `${p}`), window.requestAnimationFrame(() => {
            m = !0, a.observe(n);
          });
        });
        return a.observe(n), () => a.disconnect();
      }
    }, [e]), /* @__PURE__ */ l(
      i.Tablist,
      {
        ...t,
        className: u(c.segmensTablist, s),
        ref: e
      }
    );
  }
), O = Object.assign(w, {
  Panel: i.Panel,
  Tablist: S,
  Tab: f(function({ className: s, tracking: t = !0, ...r }, e) {
    return /* @__PURE__ */ l(
      i.Tab,
      {
        ...r,
        className: u(c.segment, s),
        ref: e,
        tracking: t && {
          eventCategory: "segments",
          ...t === !0 ? {} : t
        }
      }
    );
  })
});
export {
  O as Segments
};
//# sourceMappingURL=segments.js.map
